<template><div><h1 id="auftragsfilter" tabindex="-1"><a class="header-anchor" href="#auftragsfilter"><span>Auftragsfilter</span></a></h1>
<p>Auftragsfilter — Parametrisierung Auftragsfilter</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Um Aufträge gesammelt bearbeiten zu können, können Aufträge über den Auftragsfilter eingegrenzt zur Anzeige gebracht werden. Der Auftragsfilter kann auch zum Zählen von Aufträgen (mit bestimmten Kriterien) verwendet werden.</p>
<p>Pfad: <code v-pre>Verkauf → Aufträge</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Verarbeitungsrt(en)</dt>
<dd>Aufträge mit Verarbeitungsarten, mehrere wählbar</dd>
<dt>von Auftragsnummer (von-bis)</dt>
<dd>Eingrenzung nach Auftragsnummer, 0 = unbegrenzt</dd>
<dt>Auftragsart</dt>
<dd>Einschrämkung nach <a class="link" href="ft.refdata.tblaufart.html" title="Auftragsart">Auftragsart</a></dd>
<dt>Erfassungsdatum (von-bis)</dt>
<dd>Datum der Auftragserfassung</dd>
<dt>Verarbeitungsdatum (von-bis)</dt>
<dd>Datum der Verarbeitung</dd>
<dt>vollständig fakturierte</dt>
<dd>Einschränkung nach vollständig gelieferten Aufträgen</dd>
<dt>teilweise fakturierte</dt>
<dd>Einschränkung nach teilgelieferten Aufträgen</dd>
<dt>nicht fakturierte</dt>
<dd>Einschränkung nach noch nicht gelieferten Aufträgen</dd>
<dt>nur mit Vorauszahlung</dt>
<dd>Einschränkung nach Aufträgen, die über Vorauszahlung abgewickelt werden</dd>
<dt>mit Auftraggeber</dt>
<dd>Einschränkung nach bestimmter Auftraggeberadresse</dd>
<dt>nur Aufträge mit Artikel</dt>
<dd>Einschränkung nach bestimmtem Artikeln (Angabe von 3 verschiedenen gleichzeitig möglich)</dd>
<dt>Bestellart</dt>
<dd>Einschränkung nach Bestellart</dd>
<dt>Zählungsergebnis</dt>
<dd>Anzeige des Ergebnisses, wenn nur Zähllauf durchgeführt wird</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="zahlen" tabindex="-1"><a class="header-anchor" href="#zahlen"><span>zählen</span></a></h3>
<p>Berechnet die Anzahl Aufträge, und zeigt diese in der Maske an.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


